import { render, staticRenderFns } from "./OrderRecord.vue?vue&type=template&id=4c349ff4"
import script from "./OrderRecord.vue?vue&type=script&lang=js"
export * from "./OrderRecord.vue?vue&type=script&lang=js"
import style0 from "./OrderRecord.vue?vue&type=style&index=0&id=4c349ff4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports